<app-sidebar></app-sidebar>

<div class="p-4 lg:p-[30px] md:ml-64 bg-[var(--color-gray-6)] min-h-screen flex flex-col gap-6 xl:gap-[30px]">

    <app-header></app-header>

    <div>
        <router-outlet></router-outlet>
    </div>
</div>